<template>
  <v-row density="compact">
    <p>
      For example, only choose stocks trading within 5% above their 2-year high, or choose stocks
      trading at least 60% below their 3-year high
    </p>
    <p>
      Only consider stocks whose price is
      <span v-if="rule.config.type == 'within'">
        {{ rule.config.type }}
      </span>
      <span v-else>down more than </span>

      {{ rule.config.min }}% of the {{ rule.config.days }} day high
    </p>
    <v-col cols="12" sm="6">
      <v-select
        :model-value="rule.config.type"
        :items="['within', 'down']"
        label="Within or Down"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('type', $event)"
      />
    </v-col>
    <v-col cols="12" sm="6">
      <v-text-field
        :model-value="rule.config.min"
        density="compact"
        hide-details
        variant="outlined"
        label="Percent Range"
        @update:model-value="updateConfig('min', $event)"
      />
    </v-col>
    <v-col cols="12" sm="6">
      <v-select
        :model-value="rule.config.days"
        :items="[5, 10, 15, 20, 50, 90, 125, 250, 500, 750, 1000]"
        label="# of Trading Days"
        hint=""
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('days', $event)"
      />
    </v-col>
  </v-row>
</template>

<script>
// Modules
import { mapFields } from '@/store/helpers'

export default {
  components: {},
  props: {
    rule: { type: Object, required: true }
  },
  emits: ['update:rule'],
  data() {
    return {
      editedTa: {
        enabled: true,
        type: 'down',
        rule_type: 'high',
        days: 250,
        min: 3,
        long_short: 'long'
      },
      defaultTa: {
        enabled: true,
        type: 'down',
        rule_type: 'high',
        days: 250,
        min: 3,
        long_short: 'long'
      }
    }
  },

  computed: {
    ...mapFields({
      appcriteria: 'app.whaleTraderCriteria',
      criteria: 'app.whaleTraderCriteria.signals.trend_signal',
      enabled: 'app.whaleTraderCriteria.signals.trend_signal.enabled',
      signalView: 'app.signalView',
      exit_time_periods: 'app.exit_time_periods'
    })
  },

  watch: {},

  mounted() {
    if (!this.rule.config || !this.rule.config.rule_type || this.rule.trend != 'high') {
      this.$emit('update:rule', { ...this.rule, config: Object.assign({}, this.defaultTa) })
    }
  },

  methods: {
    updateConfig(key, value) {
      this.$emit('update:rule', { ...this.rule, config: { ...this.rule.config, [key]: value } })
    }
  }
}
</script>
